export default __webpack_public_path__ + "static/media/Belt of Conflagrant Flame.46fe4bbb.jpg";